<template>
	<div class="search-provider px-lg-4">
        <div class="row">
            <div class="col search-text-top text-left">
                Zadejte ulici: {{ string }} <button @click="update" class="btn btn-primary"> Hledej </button>
            </div>
        </div>

        <div class="row">
            <div class="col mt-2 mt-lg-1">
                <input class="search-text-input form-control" placeholder="např. Purkyňova" v-model="string" v-on:keyup.enter="update">
            </div>
        </div>

        <div v-if="! loading" class="finals-part mt-2" >
            <div v-for="(r, rIndex) of finalResults || []" :key="r.adresni_misto" class="hold" >
              <div class="search-text-finals" @click="getData(r)"  :class="{ active: isActive(r.adresni_misto) }">
                  <span style="font-weight: bold;"> {{ r.city_name }} </span>
                  <span style="color: gray;"> ({{ r.city_part_name }}, {{ r.so_type }}) </span>
                  <span> {{ r.city_street_name }} </span>
                  <span> {{ r.number_popisne }}/{{ r.number_orientacni + (r.sign_orientacni !== null ? r.sign_orientacni : '') }} - {{ r.psc }} </span>
              </div>
              <!-- <button v-if="canSend" class="wttx-butt btn" @click="showModal(r,(r.city_name + ' (' + r.city_part_name + ') - ' + r.city_street_name + ' ' + r.so_type + ' ' + r.number_popisne + '/' + r.number_orientacni + (r.sign_orientacni !== null ? r.sign_orientacni : '') + ' - ' + r.psc + '(RUIAN: ' + (r.created ? 'nedostupny' : r.adresni_misto) + ')'))"> wttx ověření </button> -->
            </div>
		    </div>

        <tile v-else :loading="loading" height="10" width="10"></tile>

        <b-modal id="modal-2" title="BootstrapVue" :size="'lg'" @hidden="resetModal">
			<template #modal-title>
				Odeslat email pro kontrolu wttx?
			</template>
			<div class="d-block text-center">
				<div class="row">
					<input type="textarea" class="form-control col-9 ml-2" id="ruian" placeholder="Zadejte adresu." v-model="displayText" :disabled="isDisabled" />
				</div>

			</div>
			<template #modal-footer>
				<div class="row">
					<button class="btn btn-secondary px-3 py-2 mr-2" @click="closeModal"> Ne </button>
					<button class="btn btn-primary px-3 py-2 mr-2" @click="sendMailOver(displayText, displayRuian)"> Ano </button>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'
import modal from '@/components/modal.vue'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
	name: 'SearchProvider',

    components: {
        modal,
    },

    data () {
		return {
            string: null,
            results: [],
            finalResults: [],
            selected: null,
            loading: false,
            isModalVisible: false,
            displayText: null,
            canSend: false,
            isDisabled: false,
            gettingData: false,
		}
    },

    mounted () {
        this.loadPowers()
        this.checkDisabled()
    },

	methods: {
        ...mapGetters([
            'getPowers',
            'getUserObject',
        ]),

        checkDisabled () {
            const usrObj = this.getUserObject()
            if (usrObj.hasOwnProperty('flags') && usrObj.flags && usrObj.flags.includes('wttx-uneditable')) {
                this.isDisabled = true
            }
        },

        resetModal () {
		},

        loadPowers() {
            const powers = this.getPowers()
            if (powers.includes('overeni-emailem')) {
                this.canSend = true
            } else {
                this.canSend = false
            }
        },

        showModal(r, text) {
            if (! this.canSend) {
                return
            }
            this.displayText = text
            this.displayRuian = '(RUIAN: ' + (r.created ? 'nedostupny' : r.adresni_misto) + ')'
			this.$bvModal.show('modal-2')
        },

        closeModal() {
			this.$bvModal.hide('modal-2')

        },

        async update() {
            const user = this.getUserObject()
            if (user.name === 'hros') {
                return
            }

            this.$emit('startLoading')
            this.loading = true
            this.finalResults = []

            this.$emit('holdResults', [])

            const final = await AdditionsService.secondHit(this.string, user.name)

            this.finalResults = final.data
            this.loading = false
        },

		async getData (r) {
            if (this.gettingData) {
                return
            }

            this.$emit('startSearch', r.adresni_misto, true)

            this.gettingData = true
            // this.$emit('startLoading')
            this.selected = r.adresni_misto
            // const user = this.getUserObject()
            // const items = await AdditionsService.fetchProducts(r.adresni_misto, user.name)
            // this.$emit('holdResults', items.data, true)

            // this.$emit('stopLoading')
            this.gettingData = false
        },

        isActive(misto) {
            return this.selected === misto
        },

        sendMailOver(str, ruian) {
            const usrObj = this.getUserObject()
            let mail = usrObj.email
            let newStr = str

            if (usrObj.hasOwnProperty('flags') && usrObj.flags && usrObj.flags.length && usrObj.flags.includes('neomezeny')) {
                mail = 'support@nejpripojeni.cz'
                newStr = newStr + ' Odesláno uživatelem ' + userObj.name
            }

            AdditionsService.sendMail(newStr, mail, ruian)
            this.closeModal()
            alert('Mail odeslán na vodafone@conectart.cz')
        }
	},
}
</script>

<style lang="stylus" scoped>
.search-provider
    border-radius 20px
    padding 15px

.search-text-top
    padding-left 15px
    font-weight bold
    color rgb(1, 141, 134)

.search-text-input
    font-weight bold
    padding-left 15px

.finals-part
    max-height 300px
    overflow-y scroll
	display flex
	flex-direction column

.finals-part-test
    max-height 300px
    overflow-y scroll

.foo
    background-color red
    display flex
    flex-direction row
    justify-content space-between

.modal-butt-yes
    height 30px
    width 120px
    border none
    background-color #4CA5F9
    cursor pointer

.modal-butt-no
    height 30px
    width 120px
    border none
    background-color red
    cursor pointer

.hold
    display flex
    flex-direction row
    margin-top 5px

.search-text-finals
    border 1px solid gray
    padding 5px 0px 5px 5px
    cursor pointer
    padding-right 50px
    border-radius 3px
    text-align left
    background-color white

.active
    background-color #d6d6d6

.wttx-butt
    float right
    border none
    background-color #4CA5F9
    color white

    margin-left 10px

</style>




// WEBPACK FOOTER //
// src/components/search_provider/SearchProvider.vue